import React, { useState, useEffect, useRef , useLayoutEffect} from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newSubProductCreation,resetSubProductCreatiion,imageuploadProcess,getSingleSubProduct ,SubProductModification,imageUploadFailureProcess,getAllSubProductImage,subproductImageDeletion,getSingleSubProductImage} from "./subproductAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { newItenaryCreation,getSingleProductItenary,itenaryModification, inclusionDeletion,exclusionDeletion} from "../itenary/itenaryAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { FaArrowLeft } from 'react-icons/fa';
import './testt.css';

import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi2";
import { useNavigate,useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaEye, FaArrowAltCircleRight, FaTrash, FaPlus} from 'react-icons/fa';
import { axiosPrivate } from '../../../hooks/axiosPrivate';

import { getAllProduct } from "../product/productAction";
import moment from 'moment';
const ModifySubProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const firstUpdate = useRef(true);
  const {id}=useParams();
  const {pid}=useParams();
  const {pname}=useParams();
  const fileref = useRef('');
  const [productid,setProductid]= useState('');
  const [subproductname,setSubproductname]= useState('');
  const { SubProductId,subproductimageall,pcMessage } = useSelector((state) => state.subproductList);

  const [status,setStatus]= useState('');
  const [isithourly,setIsItHourly]= useState('');
  const [isitvehicle,setIsItVehicle]= useState('');
  console.log("isithourly",isithourly)
  const [isAlive,setIsAlive] = useState(true);
  const [mainimage,setMainImage]= useState('');

  const [disupdate , setDisupdate]  = useState(true);
  const [disupdate2 , setDisupdate2]  = useState(true);
  const [paxlimitshow, setPaxlimitShow] = useState(false);
  const [occresshow, setOccresShow] = useState(false);
  const [paxlimitno,setPaxlimitNo]= useState('');
  const [paxlimit,setPaxlimit]= useState('');
  const [occres,setOccres]= useState('');
  const [adultper,setAdultper]= useState('');
  const [childper,setChildper]= useState('');
  const [infantper,setInfantper]= useState('');
  const [status2,setStatus2]= useState('');
  const [timelimitshow, setTimeLimitShow] = useState(false);
  const [bhours,setbhours]= useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [progressInfos, setProgressInfos] = useState([]);
  const [message, setMessage] = useState([]);

  const [minmaxshow, setMinMaxShow] = useState(false);
  const [minmaxshow2, setMinMaxShow2] = useState(false);
  const [dayShow,setDayShow] = useState(false);
  const [timeShow,setTimeShow] = useState(false);
  const [fromtime,setFromtime]= useState('');
  const [disupload , setDisupload] = useState(true);
  const [totime,setTotime]= useState('');

  const [inclusion, setInclusion] = useState([]);
  const [sectionsIn, setSectionsIn] = useState([]);
  const [sectionsEx, setSectionsEx] = useState([]);
  const [exclusion, setExclusion] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [terms,setTerms]= useState('');
  const [abouttour,setAboutTour]= useState('');
  const [addinfo,setAddInfo]= useState('');
  const [pickuploc,setPickUpLoc]= useState('');
  const [timelimit,setTimelimit]= useState('');



  const [dailystarttime,setDailystarttime]= useState('');
  const [dailyendtime,setDailyendtime]= useState('');
  const { itenary } = useSelector((state) => state.productitenaryList);

  const data1  = useSelector((state) => state.productitenaryList?.itenary?.data1 || []);
  const data2  = useSelector((state) => state.productitenaryList?.itenary?.data2 || []);
  const data3  = useSelector((state) => state.productitenaryList?.itenary?.data3 || []);
  // const datamap = [data1];
  // console.log("top",datamap)

  const SubProductRef = useRef(null);
  const [subproducts, setSubProducts] = useState({
    id:"",
    productid:"",
    subproductname:"",
    status:""
  });

    
const handlePaxlimit = (e) =>{
  setDisupdate(false)
  const checked = e.target.checked;

  
  if(paxlimit == true){
    setPaxlimit(false);
    
    setSubProducts({ ...subproducts, paxlimit: '0' });

    setPaxlimitShow(false)
  }else if(paxlimit == false){
    setPaxlimit(true)
    setSubProducts({ ...subproducts, paxlimit: '1' });
    setPaxlimitShow(true);
  }
}

const handleIsItHourly = (e) =>{
  setDisupdate(false)

  const checked = e.target.checked;

  
  if(isithourly == true){
    setIsItHourly(false);
    setSubProducts({ ...subproducts, isithourly: '0' });

    setMinMaxShow(false);
  }else if(isithourly == false){
    setIsItHourly(true);
    setSubProducts({ ...subproducts, isithourly: '1'});

    setMinMaxShow(true);
  }
}

const handleIsItVehicle = (e) =>{
  setDisupdate(false)

  const checked = e.target.checked;

  
  if(isitvehicle == true){
    setIsItVehicle(false);
    setSubProducts({ ...subproducts, isitvehicle: '0' });

    setMinMaxShow2(false);
  }else if(isitvehicle == false){
    setIsItVehicle(true);
    setSubProducts({ ...subproducts, isitvehicle: '1'});

    setMinMaxShow2(true);
  }
}



    
const handleOccresupdate = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name == "occres" && checked){
    setOccres(1);
    
    setSubProducts({ ...subproducts, occres: 1 });

    setOccresShow(true)
  }else {
    setOccres(0)
    setSubProducts({ ...subproducts, occres: 0 });
    setOccresShow(false);
  }
}


const handleAdultupdate = (e) =>{
  setDisupdate(false)
  const checked = e.target.checked;

  
  
  if (adultper == true) {
    setAdultper(false)
    setSubProducts({ ...subproducts, adultper: '0'});

  } 
  else if(adultper == false) {
    setAdultper(true)
    setSubProducts({ ...subproducts, adultper: '1' });
  }
}

const handleChildupdate = (e) =>{

  setDisupdate(false)
  const checked = e.target.checked;

  
  if (childper == true) {
    setChildper(false)
    setSubProducts({ ...subproducts, childper: '0'});

  } 
  else if(childper == false) {
    setChildper(true)
    setSubProducts({ ...subproducts, childper: '1' });
  }
}


const handleInfantupdate = (e) =>{
  setDisupdate(false)
  const checked = e.target.checked;

  
  if (infantper == true) {
    setInfantper(false)
    setSubProducts({ ...subproducts, infantper: '0'});

  } 
  else if(infantper == false) {
    setInfantper(true)
    setSubProducts({ ...subproducts, infantper: '1' });
  }
}

  function loadSubProduct(id){
    dispatch(getSingleSubProduct(id));
    setSubProducts({
        id:id,
        productid:spData.product_id,
        subproductname:spData.subproduct_name,
        paxlimit:spData.pax_limit,
        paxlimitno:spData.pax_limit_no,
        occres:spData.occ_res,
        adultper:spData.adult_per,
        childper:spData.child_per,
        infantper:spData.infant_per,
        isithourly:spData.isithourly,
        isitvehicle:spData.isitvehicle,
        bdays:spData.bdays,
        bhours: spData.bhours,
        fromtime:spData.from_time,
        totime:spData.to_time,
        mintime:spData.min_time,
        maxtime:spData.max_time,
        minpax:spData.min_pax,
        maxpax:spData.max_pax,
        status:spData.status,
       
    });
    
 }



//  function loadSubItenary(id){
//   dispatch(getSingleProductItenary(id));
  
//   setDailystarttime(data1[0]?.daily_start_time);
//   setDailyendtime(data1[0]?.daily_end_time);
//   setAboutTour(data1[0]?.about_tours);
  
// }


  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
   
      loadSubProduct(id);
      // loadSubItenary(id);

   
      return () => setIsAlive(false)
    
    }
  },[isAlive]);

  useEffect(() => { 
    dispatch(getAllProduct());
   
    loadSubProduct(id);
    setSubProducts({
      id:id,
      productid:"",
      subproductname:"",
      paxlimit:"",
      paxlimitno:"",
      status:"",
     
  });


    return () => setIsAlive(false)
    
   
     }, [isAlive]);

   
  useEffect(() => {
    dispatch(getSingleSubProduct(id));
    dispatch(getSingleProductItenary(id));
    dispatch(getAllSubProductImage());
    dispatch(getSingleSubProductImage(id));
 
  }, [pcMessage]);



  
  const subproductData = useSelector((state) => state.subproductList);
  const spData = JSON.parse(JSON.stringify(subproductData.pSDetails));
  
  useEffect(() => {
    if (subproductData && subproductData.pSDetails && subproductData.pSDetails.id === Number(id)) {
      const spData = JSON.parse(JSON.stringify(subproductData.pSDetails));
      const initialRates = Object.keys(spData).map((key) => (spData[key] || '').toString());
      setSubProducts((prevState) => ({
        ...prevState,
        id:spData.id,
        productid:spData.product_id,
        subproductname:spData.subproduct_name,
        paxlimit:spData.pax_limit,
        paxlimitno:spData.pax_limit_no,
        occres:spData.occ_res,
        adultper:spData.adult_per,
        childper:spData.child_per,
        infantper:spData.infant_per,
        isithourly:spData.isithourly,
        isitvehicle:spData.isitvehicle,
        bdays:spData.bdays,
        bhours: spData.bhours,
        fromtime:spData.from_time,
        totime:spData.to_time,
        mintime:spData.min_time,
        maxtime:spData.max_time,
        minpax:spData.min_pax,
        maxpax:spData.max_pax,
        status:spData.status,
      }));
      setFromtime(spData?.from_time);
      setTotime(spData?.to_time);
      setbhours(spData?.bhours);
    }
  }, [subproductData, id]);
  useEffect(() => {
    setPaxlimit(spData?.pax_limit)
    setPaxlimitShow(spData?.pax_limit === 1 ? true : false)
    setIsItHourly(spData?.isithourly)
    setMinMaxShow(spData?.isithourly === 1 ? true : false)
    setIsItVehicle(spData?.isitvehicle)
    setMinMaxShow2(spData?.isitvehicle === 1 ? true : false)
    setTimelimit(spData?.from_time !== '' || spData?.to_time !== '' ? 1: 0)
    setTimeLimitShow(spData?.from_time !== '' || spData?.to_time !== '' ? true: false)
    setOccres(spData?.occ_res)
    setOccresShow(spData?.occ_res === 1 ? true : false)

    setAdultper(spData?.adult_per)
    setChildper(spData?.child_per)
    setInfantper(spData?.infant_per)
    const setMainValue = subproductimageall?.filter(obj => obj.subproduct_id == id).map((item)=>{
      return item?.main_image
    })
    console.log(",ainsnshdbbdbd",setMainValue)
    setMainImage(setMainValue[0])
    
  
  }, [spData?.pax_limit,spData?.occ_res,spData?.adult_per,spData?.child_per,spData?.infant_per,spData?.isithourly,spData?.isitvehicle,spData?.from_time,spData?.to_time])

  useEffect(() => {
  
    setDailystarttime(data1[0]?.daily_start_time);
    setDailyendtime(data1[0]?.daily_end_time);
    setAboutTour(data1[0]?.about_tours);
    setAddInfo(data1[0]?.additional_info);
    setPickUpLoc(data1[0]?.pickup_loc);
    setTerms(data1[0]?.terms);
    setInclusion(data2);
    setStatus2(data1[0]?.status)
    
   
    
  
  }, [data1,data2])

    
  useEffect(() => {

    if (data2[0]?.subproduct_id === Number(id) &&  data2.length > 0) {
      const updatedSections33 = data2.map((section) => ({
        id: section.id,
        inclusion: section.service_include,
      }));
  
      setSectionsIn(updatedSections33);
      setInclusion(updatedSections33);
    }
  }, [data2]);
  useEffect(() => {

    if (data3[0]?.subproduct_id === Number(id) &&  data3.length > 0) {
      const updatedSections33 = data3.map((section) => ({
        id: section.id,
        exclusion: section.service_include,
      }));

      setSectionsEx(updatedSections33);
      setExclusion(updatedSections33);
    }
  }, [data3]);
  
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { products } = useSelector((state) => state.productList);

  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);

  const onBack = () => {
   
    navigate('/subproductListId/' + pid + "/" + pname); 
 }

//  const handleRemoveSectionIn = (index) => {
//   setSectionsIn(prevSections => prevSections.filter((_, i) => i !== index));
// };
const handleRemoveSectionIn = (index, idd) => {
  console.log(idd);
  if (index < data2.length) {
    // If the section is from the database, delete it directly from the database
    const sectionToRemove = data2[index];
    // Call the appropriate delete function or API endpoint to delete the section from the database
    Swal.fire({
      title: 'Are you sure want to delete this Inclusion?',
      showDenyButton: true,
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(inclusionDeletion(idd)).then(() => {
          dispatch(getSingleProductItenary(id));
          setSectionsIn((prevSections) => prevSections.filter((_, i) => i !== index));

         
          Swal.fire('Inclusion Details Deleted Successfully!', '', 'success');
        });
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
      }
    });


    setInclusion((prevInclusion) => {
      const updatedInclusion = [...prevInclusion];
      updatedInclusion.splice(index, 1);
      return updatedInclusion;
    });
  } else {
    // If the section is not from the database, remove it from the state
    setSectionsIn((prevSections) => prevSections.filter((_, i) => i !== index));

    setInclusion((prevInclusion) => {
      const updatedInclusion = [...prevInclusion];
      updatedInclusion.splice(index, 1);
      return updatedInclusion;
    });
  }
};



const handleRemoveSectionEx = (index, idd) => {
  console.log(idd);
  if (index < data3.length) {
    // If the section is from the database, delete it directly from the database
    const sectionToRemove = data3[index];
    // Call the appropriate delete function or API endpoint to delete the section from the database
    Swal.fire({
      title: 'Are you sure want to delete this Exclusion?',
      showDenyButton: true,
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(exclusionDeletion(idd)).then(() => {
          dispatch(getSingleProductItenary(id));
          setSectionsEx((prevSections) => prevSections.filter((_, i) => i !== index));

         
          Swal.fire('Exclusion Details Deleted Successfully!', '', 'success');
        });
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
      }
    });

    // After successful deletion, update the state by removing the section from the sections array

    // Remove the infant rate from the infantrate state
    setExclusion((prevExclusion) => {
      const updatedExclusion = [...prevExclusion];
      updatedExclusion.splice(index, 1);
      return updatedExclusion;
    });
  } else {
    // If the section is not from the database, remove it from the state
    setSectionsEx((prevSections) => prevSections.filter((_, i) => i !== index));

    setExclusion((prevExclusion) => {
      const updatedExclusion = [...prevExclusion];
      updatedExclusion.splice(index, 1);
      return updatedExclusion;
    });
  }
};
const selectFiles = (event) => {
  setDisupload(false);
  let images = [];
  let selectedFiles = [];

  for (let i = 0; i < event.target.files.length; i++) {
    const file = event.target.files[i];
    if (file.type === 'image/webp') {
      images.push(URL.createObjectURL(file));
      selectedFiles.push(file);
    }
  }

  setSelectedFiles(selectedFiles);
  setImagePreviews(images);
  setProgressInfos([]);
  setMessage([]);
};
// const handleRemoveSectionEx = (index) => {
//   setSectionsEx(prevSections => prevSections.filter((_, i) => i !== index));
// };
const onSubProductImageDelete = (id, e) => {
  e.preventDefault();
  Swal.fire({
      title: 'Are you sure want to delete this Image?',
      showDenyButton: true,
      icon:'error',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      }
    }).then((result) => {
      
      if (result.isConfirmed) {
        dispatch(subproductImageDeletion(id)).then(() => {
          dispatch(getAllSubProductImage()); 
          Swal.fire('Sub Product Image Deleted Successfully!', '', 'success')
        })
    } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
      }
    })


}


const handleAddSectionIn = () => {
  setSectionsIn(prevSections => [...prevSections, { inclusion: Array(1).fill('') }]);
};

const handleAddSectionEx = () => {
  setSectionsEx(prevSections => [...prevSections, { exclusion: Array(1).fill('') }]);
};


  const canUpdate = dailystarttime !== data1[0]?.daily_start_time || dailyendtime !== data1[0]?.daily_end_time || abouttour !== data1[0]?.about_tours || terms !== data1[0]?.terms || pickuploc !== data1[0]?.pickup_loc || addinfo !== data1[0]?.additional_info  || status2 !== data1[0]?.status || data2[0]?.service_include !== inclusion[0]?.inclusion || data3[0]?.service_include !== exclusion[0]?.exclusion

 const handleOnSubmitItenary = (e) => {
  e.preventDefault();
 
if(dailystarttime !== data1[0]?.daily_start_time ||
  dailyendtime !== data1[0]?.daily_end_time ||
  abouttour !== data1[0]?.about_tours ||
  terms !== data1[0]?.terms ||
  pickuploc !== data1[0]?.pickup_loc ||
  addinfo !== data1[0]?.additional_info ||
  status2 !== data1[0]?.status || data2[0]?.service_include !== inclusion[0]?.inclusion || data3[0]?.service_include !== exclusion[0]?.exclusion
  ){
    const itenaryModification1 = {
      id,
        dailystarttime,
        dailyendtime,
        abouttour,
        terms,
        pickuploc,
        addinfo,
        inclusion: inclusion,
        exclusion: exclusion,
        status2

    };
    dispatch(
      itenaryModification(itenaryModification1)
    )
    Swal.fire({
        title: 'Success!',
        text: 'Itinerary Details Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      });
      navigate('/SubproductListId/' + pid + "/" +pname); 


  }else if(dailystarttime == undefined && dailyendtime == undefined){
    Swal.fire('Please Enter Start Time and End Time', '', 'warning');
    

  }else{
    Swal.fire('No changes made!', '', 'warning');
  }
      

};



const renderCommissionFieldsIn = (sectionIndex) => {
  const handleInclusionChange = (e) => {
    const { value } = e.target;

    setInclusion((prevInclusion) => {
      const updatedInclusion = [...prevInclusion];
      updatedInclusion[sectionIndex] = {
        ...updatedInclusion[sectionIndex],
        inclusion: value,
      };
      return updatedInclusion;
    });
  };

  return (
    <div key={sectionIndex}>
      <div style={{ display: 'flex', marginLeft: '22px' }}>
        <Form.Control
          name="inclusion"
          style={{ width: '870px', height: '36px', marginLeft: '73px' }}
          type="text"
          value={inclusion[sectionIndex]?.inclusion || ''}
          onChange={handleInclusionChange}
          required
          autoComplete='off'
          placeholder="Enter Inclusion Details"
        />
      </div>
    </div>
  );
};


const renderCommissionFieldsEx = (sectionIndex) => {
  const handleexclusionChange = (e) => {
    const { value } = e.target;

    setExclusion((prevExclusion) => {
      const updatedExclusion = [...prevExclusion];
      updatedExclusion[sectionIndex] = {
        ...updatedExclusion[sectionIndex],
        exclusion: value,
      };
      return updatedExclusion;
    });
  };

  return (
    <div key={sectionIndex}>
      <div style={{ display: 'flex', marginLeft: '22px' }}>
        <Form.Control 
        name="exclusion"
        style={{ width: '870px', 
        height: '32px', 
        marginLeft: '73px' }} 
        type="text" 
        value={exclusion[sectionIndex]?.exclusion || ''}
        onChange={handleexclusionChange} 
        required="true" 
        autoComplete='off' 
        placeholder="Enter Exclusion Details" />


      </div>

    </div>
  );
};


  const handleOnChange = e => {
    console.log("eeeeeeee",e.target.name)
    console.log("eeeeeeee",e.target.value)
    setDisupdate(false)
    const name = e.target.name;
    const value = e.target.value;
    
    setSubProducts({ ...subproducts, [name]: value });
    
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
 
      const {
        id,
        productid,
        subproductname,
        paxlimit,
        paxlimitno,
        occres,
        adultper,
        childper,
        infantper,
        isithourly,
        isitvehicle,
        bdays,
        bhours,
        fromtime,
        totime,
        mintime,
        maxtime,
        minpax,
        maxpax,
        status
      } = subproducts

    if (productid !== "" ||
      subproductname !== "" ||
      paxlimit !== "" ||
      paxlimitno !== "" ||
      status !== "" || 
      occres !== "" || 
      adultper !== "" || 
      childper !== "" || 
      infantper !== "" ||
      isithourly !== "" || 
      isitvehicle !== "" || 
      bdays !== "" || 
      bhours !== "" || 
      fromtime !== "" || 
      totime !== "" ||
      mintime !== "" || 
      maxtime !== "" ||
      minpax !== "" || 
      maxpax !== ""){

        const newSubProductCreation1 = {
          id,
          productid,
          subproductname,
          paxlimit,
          paxlimitno,
          occres,
          adultper,
          childper,
          infantper,
          isithourly,
          isitvehicle,
          bdays,
          bhours,
          fromtime,
          totime,
          mintime,
          maxtime,
          minpax,
          maxpax,
          status,

      };
      dispatch(
        SubProductModification(newSubProductCreation1)
      )
      Swal.fire({
          title: 'Success!',
          text: 'Sub Product Details Updated Successfully',
          icon: 'success',
          confirmButtonText: 'Okay'
        })

        navigate('/SubproductListId/' + pid + "/" +pname); 
       

      }else{
        Swal.fire('No changes made!', '', 'warning');


      }
        

        
      
  
  };
  const uploadImages = (e) => {
    setDisupload(true);
      e.preventDefault();
      if (selectedFiles.length === 0) {
        // show an error message
        let failure_result = {
          message: "Please Select an image file (Webp)",
        };
        Swal.fire("Image Upload Failed!!","Please Select an image file (Webp).",'error')
        dispatch(imageUploadFailureProcess(failure_result));
        setMessage([]);
        setProgressInfos([]);
        return;
      }
    
      setMessage([]);
    
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        
        if (file.size > 1024 * 1024) {
          // Show an error message for files larger than 1MB
          let failure_result = {
            message: "Selected image is too large. Please select an image under 1MB.",
          };
          Swal.fire("Image Upload Failed!!","Selected image is too large. Please select an image under 1MB.",'error')


          dispatch(imageUploadFailureProcess(failure_result));
          setMessage([]);
          setProgressInfos([]);
          return;
        }
        
        upload(i, id, file);
      }
      
      // Reset the file input value
      fileref.current.value = '';
    
      setIsAlive(true)
    };
  // const uploadImages =  (e) => {
  //   setDisupload(true);
  //   e.preventDefault();
  //   if (selectedFiles.length==0) {
  //     // show an error message
  //     let failure_result= {
  //       message: "Please Select a image file",
       
  //     }
  //     dispatch(imageUploadFailureProcess(failure_result));
  //     setMessage([]);
  //     setProgressInfos([]);
  //     return;
  //   }
  
  //   setMessage([]);

  //   for (let i = 0; i < selectedFiles.length; i++) {
    
  //     upload(i,id, selectedFiles[i]);
  //   }
  //   fileref.current.value='';
   
  //   setIsAlive(true)
  // };
  const upload = (idx,product_id, file) => {

      
    let _progressInfos = [...progressInfos];

 
    return UploadService.upload(file,product_id, (event) => {
      _progressInfos[idx].percentage = Math.round(
        (100 * event.loaded) / event.total
      );
      setProgressInfos(_progressInfos);
    })
      .then(() => {
        setMessage((prevMessage) => [
          ...prevMessage,
          "Image Updated Successfully: " + file.name,
        ]);
     
        let success_result= {
          message: "Image Updated Successfully",
          // id: id,
         
        }
        dispatch(imageuploadProcess(success_result));
        dispatch(getAllSubProductImage());
      })
      .catch(() => {
        _progressInfos[idx].percentage = 0;
        setProgressInfos({ val: _progressInfos });

        setMessage((prevMessage) => [
          ...prevMessage,
          "Could not upload the image: " + file.name,
        ]);
      });

      
  };

  const handleBefore = (e) => {

    if (e == "Day") {
      setDayShow(true);
      setTimeShow(false)
    } else if (e == "Hour") {
      setTimeShow(true)
      setDayShow(false);
    }
  }

  const handleMainImage = (e) => {
    const checked = e.target.checked;
  
    if (e.target.name === "mainimage" && checked) {
      const payload = {
        id: id,
        mainimage: 1
      };
  
      axiosPrivate.put("/excursionsubproductimage/subproductcheckupdate", payload)
        .then(response => {
          // Handle the response if needed
         
          setMainImage(1);
          dispatch(getAllSubProductImage());
        })
        .catch(error => {
          // Handle the error if the request fails
        });
    } else {
    
      axiosPrivate.delete(`/excursionsubproductimage/deletesubproductcheck/${id}`)
        .then(response => {
          // Handle the response if needed
          setMainImage(0);
          dispatch(getAllSubProductImage());
        })
        .catch(error => {
          // Handle the error if the request fails
        });
    }
  };


  const handleTimelimit = (e) =>{
    setDisupdate(false)
    const checked = e.target.checked;
  
    
    if(e.target.name == "timelimit" && checked){
      setTimelimit(1);
      setTimeLimitShow(true)
      
    }else {
      setTimelimit(0)
      setTimeLimitShow(false);
      setFromtime('');    
      setSubProducts({ ...subproducts, fromtime: '' });
      setTotime('');    
      setSubProducts({ ...subproducts, totime: '' });

     
    }
  }

  const fromtimechange =(e) => {
    setFromtime(e.toISOString());
    setSubProducts({ ...subproducts, fromtime: e.toISOString() });

    setDisupdate(false)
  }

  const updatebhours =(e) => {
    setbhours(e.toISOString());
    setSubProducts({ ...subproducts, bhours: e.toISOString() });

    setDisupdate(false)
  }

  const totimechange =(e) => {
    setTotime(e.toISOString());
    setSubProducts({ ...subproducts, totime: e.toISOString() });

    setDisupdate(false)
  }
console.log("fromtime",fromtime)
useEffect(() => {
      

     
  let objectLength = Object.keys(selectedFiles).length;
 //  console.log('Hello-inside useeffect1',objectLength);
  let _progressInfos = [];
  

if(objectLength>0)
{
   for (let i = 0; i < selectedFiles.length; i++) {
    _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name });
   }
 }   
 //  console.log('Hello-inside useeffect push aray2',_progressInfos);
  setProgressInfos([]);
    setProgressInfos([...progressInfos, ..._progressInfos]);

     //  console.log('Hello-inside useeffect new aray3',progressInfos);
      
  
 }, [selectedFiles]);

  const canSave = Boolean (productid) && Boolean(subproductname) && Boolean(status)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);
  
  return (
    <>
      {/* <Container className="my-4 mx-4 container-xl ">
      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Update Sub Product</h4></Card.Header>
          <Card.Body> */}
           <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman',fontWeight:'600' }}>Update Sub Product</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            {/* <Link to="/subproductList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link>  */}
                           <div> <span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
                        </Row>
                        <br />
      <Tabs
      defaultActiveKey='basic'
      // activeKey={tabHandle2}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
          
            <Tab eventKey="basic" title="Sub product details">
    
           
            {/* <Row>
            <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div> */}

            {/* </Row> */}
            <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}
            <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
              <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridServiceType">
              <Form.Label>Product Name <span className='text-danger'>*</span></Form.Label>
              <Form.Select  name="productid" required="true" value={subproducts.productid ? subproducts.productid : spData.product_id} onChange={handleOnChange}>
              <option  value="" >Choose</option>
              {products.map((products,index) =>
    
              <option key={products.id} value={products.id} >{products.product_name}</option>
              )}
              </Form.Select>
              </Form.Group>
               
                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Sub Product Name</Form.Label>
                  <Form.Control type="text" ref={SubProductRef} value={subproducts.subproductname}  name="subproductname" required="true" autoComplete='off' placeholder="Enter Sub Product Name" {...register("subproductname", { required: true, mixLength: 3 })}  onChange={handleOnChange}/>
                  {errors.mobile && <p className='text-danger'> Sub Product Name required</p>}
                </Form.Group>
                </Row>
                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridIsdummy">

                  <Form.Check type="checkbox" disabled={true} ref={SubProductRef} checked={paxlimit} value={spData?.pax_limit} name="paxlimit" label="Is it a private tour ?"  {...register("paxlimit", { required: true, mixLength: 3 })} onChange={(e) => handlePaxlimit(e)} />

                </Form.Group>
                {paxlimitshow === true && <><Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Pax Limit</Form.Label>
                  <Form.Control type="number"  ref={SubProductRef} name="paxlimitno" value={subproducts.paxlimitno} required="true" autoComplete='off' placeholder="Enter the pax limit" {...register("paxlimitno", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                </Form.Group></>}

              </Row>
              <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridIsdummy">

                      <Form.Check type="checkbox" disabled={true} ref={SubProductRef} name="isithourly" checked={isithourly} value={spData?.isithourly}  label="Is it a hourly rates ?"  {...register("isithourly", { required: true, mixLength: 3 })} onChange={(e) => handleIsItHourly(e)} />

                    </Form.Group>

                    {minmaxshow === true && <>

                      <Form.Group as={Col} controlId="formGridDialyStartTime">
                        <Form.Label>Minimum Time <span className='text-danger'></span> </Form.Label>
                        <Form.Control type="number" ref={SubProductRef} name="mintime" required="true" value={subproducts.mintime} autoComplete='off' placeholder="Enter the minimum time" {...register("mintime", { required: true, mixLength: 3 })} onChange={handleOnChange} />
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridDialyEndTime">
                        <Form.Label>Maximum Time <span className='text-danger'></span> </Form.Label>
                        <Form.Control type="number" ref={SubProductRef} name="maxtime" required="true" value={subproducts.maxtime}  autoComplete='off' placeholder="Enter the maximum time" {...register("maxtime", { required: true, mixLength: 3 })} onChange={handleOnChange} />

                      </Form.Group>
                    </>}

                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridIsdummy">

                      <Form.Check type="checkbox" disabled={true} ref={SubProductRef} name="isitvehicle" checked={isitvehicle} value={spData?.isitvehicle}  label="Is it a Vehicle rates ?"  {...register("isitvehicle", { required: true, mixLength: 3 })} onChange={(e) => handleIsItVehicle(e)} />

                    </Form.Group>

                    {minmaxshow2 === true && <>

                      <Form.Group as={Col} controlId="formGridDialyStartTime">
                        <Form.Label>Minimum Pax <span className='text-danger'></span> </Form.Label>
                        <Form.Control type="number" ref={SubProductRef} name="minpax" required="true" value={subproducts.minpax} autoComplete='off' placeholder="Enter the minimum pax" {...register("minpax", { required: true, mixLength: 3 })} onChange={handleOnChange} />
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridDialyEndTime">
                        <Form.Label>Maximum Pax <span className='text-danger'></span> </Form.Label>
                        <Form.Control type="number" ref={SubProductRef} name="maxpax" required="true" value={subproducts.maxpax}  autoComplete='off' placeholder="Enter the maximum pax" {...register("maxpax", { required: true, mixLength: 3 })} onChange={handleOnChange} />

                      </Form.Group>
                    </>}

                  </Row>


                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductName">
                      <Form.Label> Booking cut off rule <span className='text-danger'></span></Form.Label>
                      <Form.Select required name="before" value={subproducts.bdays ? 'Day' : subproducts.bhours ?  'Hour' : '' } {...register("before", { required: true })} onChange={(e) => handleBefore(e.target.value)}>

                        <option value="">Choose..</option>
                        <option value="Day">Day</option>
                        <option value="Hour">Hour</option>
                      </Form.Select>  </Form.Group>
                      {subproducts.bdays !== null && (<> <Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Before Days<span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min="0" ref={SubProductRef} name="bdays" value={subproducts.bdays}  required="true" autoComplete='off' placeholder="Enter The Number of Days" {...register("bdays", { required: true, mixLength: 3 })} onChange={handleOnChange} />
                    </Form.Group></>)}

                    {subproducts.bhours !== null && ( <><Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Before Hours <span className='text-danger'></span></Form.Label>
                      <Datetime initialViewMode="time" name="bhours" updateOnView="time" value={moment(bhours).format('HH:mm A')}  dateFormat={false} timeFormat="HH:mm A" selected={bhours} onChange={(e) => updatebhours(e)} />
                    </Form.Group></>)}
                  </Row>


                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridIsdummy">

                      <Form.Check type="checkbox" ref={SubProductRef} checked={timelimit} name="timelimit" label="Allowed time slot"  {...register("timelimit", { required: true, mixLength: 3 })} onChange={(e) => handleTimelimit(e)} />

                    </Form.Group>
                    {timelimitshow === true && <>

                      <Form.Group as={Col} controlId="formGridDialyStartTime">
                        <Form.Label>Time Slot(From) <span className='text-danger'></span> </Form.Label>
                        <Datetime initialViewMode="time" name="fromtime" updateOnView="time" value={moment(fromtime).format('HH:mm A')} dateFormat={false} timeFormat="HH:mm A" selected={moment(fromtime).format('HH:mm A')} onChange={(e) => fromtimechange(e)} />
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridDialyEndTime">
                        <Form.Label>Time Slot(To) <span className='text-danger'></span> </Form.Label>
                        <Datetime initialViewMode="time" name="totime" updateOnView="time" value={moment(totime).format('HH:mm A')}  dateFormat={false} timeFormat="HH:mm A" selected={totime} onChange={(e) => totimechange(e)} />

                      </Form.Group>
                    </>}

                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridIsdummy">

                      <Form.Check type="checkbox" ref={SubProductRef} name="occres" checked={occres} value={spData?.occ_res} label="Occupancy Restrictions ?"  {...register("occres", { required: true, mixLength: 3 })} onChange={(e) => handleOccresupdate(e)} />

                    </Form.Group>
                    {occresshow === true && <>
                      <Form.Group as={Col} controlId="formGridIsdummy">

                        <Form.Check type="checkbox" ref={SubProductRef} name="sacp" checked={childper} value={spData?.child_per} style={{ fontSize: '12px' }} label="Are Children Not Allowed?"  {...register("sacp", { required: true, mixLength: 3 })} onChange={(e) => handleChildupdate(e)} />

                      </Form.Group>
                      <Form.Group as={Col} controlId="formGridIstricombo2">

                        <Form.Check type="checkbox" ref={SubProductRef} name="saip" checked={infantper} value={spData?.infant_per} style={{ fontSize: '12px' }} label="Are Infants Not Allowed?"  {...register("saip", { required: true, mixLength: 3 })} onChange={(e) => handleInfantupdate(e)} />

                      </Form.Group>
                      <Form.Group as={Col} controlId="formGridIsdummy">

                        <Form.Check type="checkbox" ref={SubProductRef} name="saap" checked={adultper} value={spData?.adult_per} style={{ fontSize: '12px' }} label="Are Adults Not Allowed?"  {...register("saap", { required: true, mixLength: 3 })} onChange={(e) => handleAdultupdate(e)} />

                      </Form.Group>


                    </>}

                  </Row>
             
                <Row className="mb-3">
               
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select value={subproducts.status ? subproducts.status : spData.status} required name="status"  onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" disabled={disupdate} className='align-middle'>
              <FontAwesomeIcon icon={faRightToBracket} /> Update
              </Button>
              </div>
              {supiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
       
    </Tab>
    <Tab eventKey="images" title="Images & Videos">
      {/* {console.log("subproductimageall",subproductimageall)} */}
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(uploadImages(e))}>
<div className="form-group multi-preview">
<Container>
          <Row xs={1} md={4}>
{subproductimageall?.filter(obj => obj.subproduct_id == id)?.map((item)=>{
  return (
    <>
    {item?.main_image == 1 ? <div className="form-group" >
      <p className="form-control" style={{width:'500px',color:'red',textAlign:'center',marginLeft:'236px'}}>Image is same as main product</p>
</div>:<>        <Col style={{marginLeft:"20px",marginBottom:"20px",marginRight:"40px"}}>
            <Card key={item.id} style={{marginTop:"20px",paddingRight:"30px",width:"250px",backgroundImage: `url(https://testapi.royalarabian.com/uploads/subproduct/${encodeURIComponent(item.subproduct_image)})`,backgroundSize:'cover'}}>
            <Card.Body>
              <Card.Title><Button className="btn btn-sm btn-danger" style={{marginLeft:"100%"}} onClick={(e) => onSubProductImageDelete(item.id, e)}><FaTrash className='fwcolor' /></Button></Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Title
               variant="top"
              //  src={"http://localhost:34567/uploads/actions/" + item.product_image}
               style={{width:"150px",height:"100px"}}
                
              // <img src={"http://localhost:34567/uploads/actions/" + item.product_image} width="350px" height="150px" alt="..." />
              />
                        
            </Card.Body>
          </Card>
        </Col></>}

  
       
      
   
    </>
    
  )
})}
   </Row>
      </Container> 

</div>
<br />
{mainimage !== 1 && <><div className="form-group">
<input type="file" className="form-control" onChange={(e) => selectFiles(e)}  multiple     accept="image/webp" ref= {fileref} />
<input type="hidden" name="subproductid" id="subproductid" value={id}/>
</div></>}

<br />

 
<Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
<Form.Check type="checkbox"  ref={SubProductRef}   disabled={subproductimageall.some(item => item.subproduct_id == id) &&  mainimage !== 1 ? true : false} name="mainimage" checked={mainimage} value={mainimage}  label="Same As Main Product ?"  {...register("mainimage", { required: true, mixLength: 3 })} onChange={(e) => handleMainImage(e)} />

  
 
</Form.Group> 
</Row>
{mainimage !== 1 && 
<><Button type="submit" className="btn btn-danger btn-block"  disabled={disupload}   >Upload</Button><br /><br/></>
}
</Form>
 {progressInfos &&
          progressInfos.map((progressInfo, index) => (
            <div className="mb-2" key={index}>
              <span>{progressInfo.fileName}</span>
              <div className="progress">
                <div
                  className="progress-bar progress-bar-info"
                  role="progressbar"
                  aria-valuenow={progressInfo.percentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: progressInfo.percentage + "%" }}
                >
                  {progressInfo.percentage}%
                </div>
              </div>
            </div>
          ))}  

{message.length > 0 && (
          <div className="alert alert-secondary" role="alert">
            <ul>
              {message.map((item, i) => {
                return <li key={i}>{item}</li>;
              })}
            </ul>
          </div>
        )}
              </Tab> 
    <Tab eventKey="itenary" title="Itinerary Details">
    <Row>
            {/* <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div> */}

            </Row>
            <br />
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitItenary(e))}> {/* handleOnSubmit() */}
    <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridDialyStartTime">
  <Form.Label>Daily Start Time <span className='text-danger'>*</span> </Form.Label>
  <Datetime initialViewMode="time" name="dailystarttime" updateOnView="time" dateFormat={false} value={moment(dailystarttime).format('HH:mm A')} timeFormat="HH:mm A" selected={dailystarttime} onChange={dailystarttime => setDailystarttime(dailystarttime)} />
    </Form.Group>

    <Form.Group as={Col} controlId="formGridDialyEndTime">
    <Form.Label>Daily End Time<span className='text-danger'>*</span> </Form.Label>
    <Datetime initialViewMode="time" name="dailyendime" updateOnView="time" dateFormat={false} value={moment(dailyendtime).format('HH:mm A')} timeFormat="HH:mm A"  selected={dailyendtime} onChange={dailyendtime => setDailyendtime(dailyendtime)} />
   
    </Form.Group>
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>About Tour<span className='text-danger'>*</span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={abouttour ? abouttour : ''}  name="abouttour" {...register("abouttour", { required: true, mixLength: 3 })}  onChange={(e) => setAboutTour(e.target.value)}
    />

</Form.Group>


</Row>

<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Additional Info<span className='text-danger'></span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={addinfo ? addinfo : ''}  name="addinfo" {...register("addinfo", { required: true, mixLength: 3 })}  onChange={(e) => setAddInfo(e.target.value)}
    />

</Form.Group>
</Row>

<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Pick Up Location<span className='text-danger'></span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={pickuploc ? pickuploc : ''}  name="pickuploc" {...register("pickuploc", { required: true, mixLength: 3 })}  onChange={(e) => setPickUpLoc(e.target.value)}
    />

</Form.Group>


</Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Terms & Conditions<span className='text-danger'>*</span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={terms ? terms : ''}  name="terms" {...register("terms", { required: true, mixLength: 3 })}  onChange={(e) => setTerms(e.target.value)}
    />

</Form.Group>


</Row>

<Card>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Service Inclusions<span className='text-danger'>*</span></h6>

<Row className='mb-3'>
 

  <div  style={{padding:'10px',marginLeft:'5px'}}><Button variant="" style={{width:'100px' ,float:'',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSectionIn}><FaPlus/>&nbsp;Add </Button></div>
{sectionsIn.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {renderCommissionFieldsIn(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',marginLeft:'',color:'red'}}   onClick={() => handleRemoveSectionIn(index,section?.id)}><FaTrash  /></Button>
    </div>
  ))}

</Row>
</Card>
<br />
<Card>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Service Exclusions<span className='text-danger'>*</span></h6>

<Row className='mb-3'>

<div style={{padding:'10px',marginLeft:'5px'}}><Button variant="" style={{width:'100px' ,float:'',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSectionEx}><FaPlus/>&nbsp;Add </Button></div>
{sectionsEx.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {renderCommissionFieldsEx(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',marginLeft:'',color:'red'}}   onClick={() => handleRemoveSectionEx(index,section?.id)}><FaTrash  /></Button>
    </div>
  ))}

</Row>
</Card>

<Row className="mb-3">

<Form.Group as={Col} controlId="formGridStatus">
<Form.Label>Status<span className='text-danger'>*</span></Form.Label>
<Form.Select required name="status2" value={status2} onChange={(e) => setStatus2(e.target.value)}>

<option value="">Choose..</option>
<option value="1">Enable</option>
<option value="0">Disable</option>
</Form.Select>
{errors.status2 && <p className='text-danger'>Status required</p>}
</Form.Group>

</Row>

<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" disabled={!canUpdate} className='align-middle'>
<FontAwesomeIcon icon={faRightToBracket} /> Submit
</Button>
</div>
{supiscLoading && (<Spinner variant='info' animation='border' />)}

</Form>
</Tab>
    </Tabs>
    </div>
    </div>
    </div>
    </>
  );
}

export default ModifySubProduct;